import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface NearCriticalTrendChartProps {
  xAxisData: string[];
  nearCriticalCount: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function NearCriticalTrendChart({
  xAxisData,
  nearCriticalCount,
  height = 260,
  showDataLabels = true,
  density = 'overview',
}: NearCriticalTrendChartProps) {
  const series = useMemo(
    () => [{ name: 'Near-critical count', data: nearCriticalCount }],
    [nearCriticalCount]
  );
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
